import { render, staticRenderFns } from "./TerminalDataCard.vue?vue&type=template&id=2df2ddd0&scoped=true&"
import script from "./TerminalDataCard.vue?vue&type=script&lang=js&"
export * from "./TerminalDataCard.vue?vue&type=script&lang=js&"
import style0 from "./TerminalDataCard.vue?vue&type=style&index=0&id=2df2ddd0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df2ddd0",
  null
  
)

export default component.exports